import {
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  SelectChangeEvent,
  styled,
} from '@mui/material'
import {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import * as form from '../modules/insurance/healthInsurance/redux/healthInsuranceRedux'
import * as auto from '../modules/insurance/AutoInsurance/redux/autoRedux'
import * as moto from '../modules/insurance/MotoInsurance/redux/motoRedux'
import * as product from '../modules/insurance/InsuranceProducts/redux/productRedux'
import * as user from '../modules/insurance/healthInsurance/redux/userRedux'
import * as filter from '../redux-commons/FilterRedux/filterRedux'
import {RootState} from '../../setup'

type Props = {
  id: string
  placeholder: string
  multiple?: boolean
  options: any[]
  labelId: string
  defaultValue: string
  handleChangeValue?: (value: string) => void
  tabName?: string
  formName?: string
  required?: boolean
  validateField?: boolean
  selectReadOnly?: boolean
  classCustom?: string
  resetValue?: boolean
}

const ITEM_HEIGHT = 48
const ITEM_PADDING_TOP = 8
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      marginTop: '10px',
    },
  },
}

const CustomInput = styled(OutlinedInput)(({theme}) => ({
  '& .MuiInputBase-input': {
    padding: '8.5px 10px !important',
  },
  '& .MuiInputLabel-root': {
    color: '#000',
    transform: 'translate(14px, -9px) scale(0.85)',
    backgroundColor: '#fff',
  },
  '& .MuiOutlinedInput-notchedOutline': {
    borderColor: 'rgba(0, 0, 0, 0.1)',
  },
  // '& legend': {
  //   '& ::selection': {
  //     background: 'red',
  //   }
  // },
}))

export const CustomInputLable = styled(InputLabel)(({theme}) => ({
  color: '#000',
  transform: 'translate(14px, -9px) scale(0.85)',
  backgroundColor: '#fff',
  pointerEvents: 'all',
}))

export const SelectField: React.FC<Props> = ({
  id,
  placeholder,
  multiple,
  options,
  labelId,
  defaultValue,
  handleChangeValue,
  tabName,
  formName,
  required,
  validateField,
  selectReadOnly,
  classCustom,
  resetValue,
}) => {
  const [selectValue, setSelectValue] = useState<string[]>([options[0]?.value])
  const [clickChangeValue, setClickChangeValue] = useState(false)
  const dispatch = useDispatch()
  const reduxUserState = useSelector((state: RootState) => state.user)
  const reduxFilterState = useSelector((state: RootState) => state.filter)
  const reduxPersonFormState = useSelector((state: RootState) => state.form)
  const reduxAutoFormState = useSelector((state: RootState) => state.auto)
  const reduxMotoFormState = useSelector((state: RootState) => state.moto)
  const reduxProductFormState = useSelector((state: RootState) => state.product)
  const currentAutoTab = reduxAutoFormState.find((o: any) => o.tabName === tabName)
  const currentProductTab = reduxProductFormState.find((o: any) => o.tabName === tabName)
  const currentMotoTab = reduxMotoFormState.find((o: any) => o.tabName === tabName)
  const currentPersonTab = reduxPersonFormState.find((o: any) => o.tabName === tabName)

  const handleSaveDataRedux = (value: string | string[] | undefined) => {
    if (formName && formName.toLowerCase().includes('formperson')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
      }
      dispatch(form.actions.addProductInfo(data))
    } else if (formName && formName.toLowerCase().includes('auto')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
      }
      dispatch(auto.actions.addAutoInfos(data))
    } else if (formName && formName.toLowerCase().includes('moto')) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
      }
      dispatch(moto.actions.addMotoInfos(data))
    } else if (
      formName &&
      (formName.toLowerCase().includes('product') ||
        formName.toLocaleLowerCase().includes('cargo') ||
        formName.toLocaleLowerCase().includes('marine') ||
        formName.toLocaleLowerCase().includes('property') ||
        formName.toLocaleLowerCase().includes('micro')) 
    ) {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
        tab: tabName ? tabName : '',
        form: formName,
      }
      dispatch(product.actions.addProductInfos(data))
    } else if (formName && formName.toLocaleLowerCase().includes('filter')) {
      let data = {
        field: id ? id : '',
        value: value ? value : '',
        filterForm: formName,
      }
      dispatch(filter.actions.updateFilterInfo(data))
    } else if (formName === 'user') {
      let data = {
        key: id ? id : '',
        value: value ? value : '',
      }
      dispatch(user.actions.addUserInfo(data))
    }
  }

  const checkDataSave = () => {
    if (formName && formName.toLowerCase().includes('person')) {
      const test = currentPersonTab.form.formData[formName][id]
      if (test !== defaultValue) {
        handleSaveDataRedux(defaultValue)
      }
    } else if (formName && formName.toLowerCase().includes('auto')) {
      const test = currentAutoTab.form.formData[formName][id]
      if (test !== defaultValue) {
        handleSaveDataRedux(defaultValue)
      }
    } else if (formName && formName.toLowerCase().includes('moto')) {
      const test = currentMotoTab.form.formData[formName][id]
      if (test !== defaultValue) {
        handleSaveDataRedux(defaultValue)
      }
    } else if (
      formName &&
      (formName.toLowerCase().includes('product') ||
        formName.toLowerCase().includes('cargo') ||
        formName.toLocaleLowerCase().includes('marine') ||
        formName.toLocaleLowerCase().includes('property'))
    ) {
      const test = currentProductTab.form.formData[formName][id]
      if (test !== defaultValue) {
        handleSaveDataRedux(defaultValue)
      }
    } else if (formName && formName.startsWith('Filter')) {
      let test = reduxFilterState[formName][id]
      if (test !== defaultValue) {
        handleSaveDataRedux(defaultValue)
      }
    } else if (formName === 'user') {
      const test = reduxUserState[id]
      if (test === null) {
        // let data = {
        //   key: id,
        //   value: defaultValue ? defaultValue.toString() : null,
        // }
        // dispatch(user.actions.addUserInfo(data))
        handleSaveDataRedux(defaultValue)
      }
    }
  }

  const handleChange = (event: SelectChangeEvent<typeof selectValue>) => {
    const {
      target: {value},
    } = event
    handleSaveDataRedux(value)
    setClickChangeValue(true)
    setSelectValue(typeof value === 'string' ? value.split(',') : value)
  }

  useEffect(() => {
    setSelectValue([defaultValue != '' ? defaultValue : options[0]?.value])
    checkDataSave()
  }, [defaultValue, formName])

  useEffect(() => {
    if (resetValue) {
      checkDataSave()
    }
  }, [resetValue])

  useEffect(() => {
    if (clickChangeValue) {
      if (selectValue[0]) {
        handleChangeValue && handleChangeValue(selectValue[0])
      } else {
        let test = JSON.stringify(selectValue)
        handleChangeValue && handleChangeValue(test)
      }
      setClickChangeValue(false)
    }
  }, [clickChangeValue])

  return (
    <div className={classCustom ? classCustom : 'field-wrapper'}>
      <FormControl error={validateField} sx={{width: '100%'}}>
        <CustomInputLable id={labelId} htmlFor={id} aria-label='test' sx={{pointerEvents: 'all'}}>
          {labelId}
          {required && <span className='input-require'> *</span>}
        </CustomInputLable>
        <Select
          labelId={labelId}
          id={id}
          multiple={multiple}
          value={selectValue}
          onChange={handleChange}
          placeholder={placeholder}
          readOnly={selectReadOnly}
          input={<CustomInput label={labelId} disabled={selectReadOnly} />}
          MenuProps={MenuProps}
          disabled={selectReadOnly}
        >
          {options.map((o, i) => (
            <MenuItem key={i} value={o.value} disabled={o.disable}>
              {o.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  )
}
